import { useState } from 'react';
import { Column, Text } from '~/commonComponents';
import { ShiftDetails } from '~/components/ConfirmCandidate/components/ShiftDetails';
import ConfirmPopup from '~/components/shared/ConfirmPopup';
import { useAppSelector } from '~/hooks';
import { Colors } from '~/themes/colors';

interface IInterviewDetailsModalProps {
  professionalId: string;
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: (notes?: string) => void;
}

export const InterviewDetailsModal = ({
  isLoading = false,
  professionalId,
  onClose,
  onConfirm,
}: IInterviewDetailsModalProps) => {
  const allCandidates = useAppSelector((state) => state.job.allCandidates);
  const [notes, setNotes] = useState('');

  const currentCounter = allCandidates?.find(
    (counter: any) => counter?.candidate?.id === professionalId,
  );

  return (
    // @ts-expect-error - ConfirmPopup still written in Javascript
    <ConfirmPopup
      closePopup={onClose}
      leftButtonAction={onClose}
      leftButtonDisabled={isLoading}
      leftButtonText="Go Back"
      rightButtonAction={() => onConfirm(notes)}
      rightButtonDisabled={isLoading}
      rightButtonLoading={isLoading}
      rightButtonText="Confirm"
      title="Interview Details"
      modalStyle={{
        paddingInline: 54,
        width: 500,
      }}
    >
      <Column width="100%" marginBottom={26}>
        {currentCounter && (
          <ShiftDetails currentCounter={currentCounter} hasBorderStyle={false} isLiteVersion />
        )}

        <Column gap={8} marginTop={24}>
          <Text bold>Include Optional Notes:</Text>
          <textarea
            className="text_notes"
            style={{
              borderWidth: 0,
              borderRadius: 10,
              backgroundColor: Colors.neutral_50,
              boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.25) inset',
              padding: '12px 20px',
              width: 'auto',
              height: 80,
            }}
            placeholder="Notes for Dental Professional"
            value={notes}
            onChange={(e) => setNotes(e.target.value)}
          />
        </Column>
      </Column>
    </ConfirmPopup>
  );
};
